module.exports = __webpack_public_path__ + "img/Асептический некроз полулунной кости (болезнь Кинбека).80e7561f.jpg";